import { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useScrollToTop } from '../../hooks/useScrollToTop'
import { useUIRedux } from '../../hooks/useUIRedux'
import { selectIsLogoutPopupOpen } from '../../store/slices/uiSlice'
import AddToCartNotification from '../AddToCartNotification/AddToCartNotification'
import AddToWishlistNotification from '../AddToWishlistNotification/AddToWishlistNotification'
import CookieConsent from '../ui/CookieConsent/CookieConsent'
import Footer from '../Footer/Footer'
import FooterCheckout from '../FooterCheckout/FooterCheckout'
import Header from '../Header/Header'
import HeaderAccount from '../HeaderAccount/HeaderAccount'
import HeaderCheckout from '../HeaderCheckout/HeaderCheckout'
import LogoutPopup from '../LogoutPopup/LogoutPopup'
import styles from './Layout.module.css'

const Layout = ({ children }: PropsWithChildren) => {
  useScrollToTop()
  const { showHeader, showFooter } = useUIRedux()
  const location = useLocation()
  const isLogoutPopupOpen = useSelector(selectIsLogoutPopupOpen)

  // Визначаємо, чи це сторінка акаунту
  const isAccountPage = location.pathname.startsWith('/account')
  const isAppLegalPage =
    location.pathname === '/app/public-offer' || location.pathname === '/app/privacy-policy'

  if (isAppLegalPage) {
    return (
      <div className={styles.layout}>
        <main className={styles.appLegalMain}>{children}</main>
      </div>
    )
  }

  const renderHeader = () => {
    if (isAccountPage) {
      return <HeaderAccount />
    }
    if (showHeader) {
      return <Header />
    }
    return <HeaderCheckout />
  }

  return (
    <div className={styles.layout}>
      {renderHeader()}
      <main className={styles.main}>{children}</main>
      {showFooter && <Footer />}
      {!showFooter && <FooterCheckout />}
      <AddToCartNotification />
      <AddToWishlistNotification />
      <LogoutPopup isOpen={isLogoutPopupOpen} />
      <CookieConsent />
    </div>
  )
}

export default Layout
